// src/views/Interactive_parts/PinUtils.js
import L from 'leaflet';

export function getPersonalPinKey(mapId) {
  return `personalPins-${mapId}`;
}

function getDropPinSvg(colour) {
  const svg = encodeURIComponent(`
    <svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 47C18 47 3 30 3 17.5C3 8.5 10 2 18 2C26 2 33 8.5 33 17.5C33 30 18 47 18 47Z"
        fill="${colour}"
        stroke="#333"
        stroke-width="2"
      />
    </svg>
  `);
  return `data:image/svg+xml,${svg}`;
}

export function personalPinIcon(colour = "#4285f4") {
  return new L.Icon({
    iconUrl: getDropPinSvg(colour),
    iconSize: [36, 48],
    iconAnchor: [18, 47],
    popupAnchor: [0, -40]
  });
}
